import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appNumbersOnly]'
})
export class NumbersOnlyDirective {
  @Input() allowPaste: boolean = false; // Allow pasting by default

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];

    if (this.allowPaste && event.ctrlKey && event.key === 'v') {
      return; // Allow paste if Ctrl+V is pressed
    }

    if (allowedKeys.includes(event.key)) {
      return;
    }

    const regex = /[0-9]/;
    const inputChar = event.key;

    if (!regex.test(inputChar)) {
      event.preventDefault();
    }
  }
}
